import RichText from 'components/shared/richtext';
import React from 'react';
import classNames from 'classnames';
import styles from './tagline.module.scss';
import Button from '../../shared/button';

const hairTagline = ({ data, locale }) => (
  <section id="sectionTagline" className={styles.taglineContainer}>
    <h2 className={styles.title}>{data.title}</h2>
    {data.tagline?.json && <RichText className={styles.tagline} text={data.tagline.json} />}
    {data?.button && (
      <Button className={classNames(styles.taglineButton)} locale={locale} button={data.button} />
    )}
  </section>
);

export default hairTagline;
